
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import PhoneCallModal from "./PhoneCallModal"; 
import VideoCallIcon from "@mui/icons-material/VideoCall";
import VideoCallModal from "./VideoCallModal";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import DescriptionIcon from "@mui/icons-material/Description"; // for Progress Note
 import Card from "@mui/material/Card";
 import Modal from "@mui/material/Modal";
 import MDBox from "components/MDBox";
 import MDTypography from "components/MDTypography";
 import MDButton from "components/MDButton";
  import MDInput from "components/MDInput";
 
import {
    Alert,
    AlertTitle,
    Stack,
    Typography,
    Box,
    CircularProgress,
    Icon,
    IconButton,
    Tooltip,
} from "@mui/material";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { toast } from "react-toastify";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";
import { keyframes } from "@mui/system";
import DoctorVideoCallModal from "./DoctorVideoCallModal";

function CriticalNotificationPage() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const highlightId = location.state?.highlightId;
    const itemRefs = useRef({});

    const loginData = JSON.parse(localStorage.getItem("loginData"));
    const userid = loginData?.userid;
    const role = loginData?.role;
 const doctor_firstName= loginData?.firstName;
  const doctor_lastName= loginData?.lastName;
  const [error, setError] = useState("");
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [openDelearModal, setOpenDelearModal] = useState(false);

       const [openCallModal, setOpenCallModal] = useState(false);
  const [callNumber, setCallNumber] = useState("");
      const [openVideoCall, setOpenVideoCall] = useState(false);
  const [videoRoomName, setVideoRoomName] = useState("");
    const [openProgressModal, setOpenProgressModal] = useState(false);
    const [selectedPatientId, setSelectedPatientId] = useState(null);
    const [selectedDoctorId, setSelectedDoctorId] = useState(null);
    
    const [progressNote, setProgressNote] = useState({
      id:"",
      ccid:userid,
      patientid:"",
      notes:"",
      
  
    });
      const [selectedUserId, setSelectedUserId] = useState(null);
      const [selectedCarecordId, setSelectedCarecordId] = useState(null);
      const handleOpenProgressModal = (patientId) => {
        setSelectedPatientId(patientId);
      
        setProgressNote((prev) => ({
          ...prev,
          patientid: patientId,
          ccid: userid,     // Care coordinator ID from login
        }));
      
        setOpenProgressModal(true);
      };
          const openPhoneCall = (country, phone) => {
        const formatted = `${country}${phone}`;
        setCallNumber(formatted);
        setOpenCallModal(true);
      };
      
      
      
      
          const handleSubmit = async (e) => {
           
           e.preventDefault();
         
          if (!progressNote.notes.trim()) {
          setError("Progress note is required.");
          return;
        }
      
        if (progressNote.notes.trim().length < 3) {
          setError("Progress note must be at least 3 characters.");
          return;
        }
      
          setError(""); // clear error
           setLoading(true);
             try {
               
               const secretKey = await fetchSecretKey();
             
               
               const rawPayload = {
                     
                     doctorId:userid,
                    ccid: progressNote.ccid,
                    patientid: progressNote.patientid,
                    notes: progressNote.notes,
                   };
           
               console.log("Raw Payload Before Encryption:", rawPayload); 
           
               const encryptedData = encryptBody(rawPayload, secretKey);
           
               console.log("Encrypted Payload:", encryptedData);
           
               const token = JSON.parse(localStorage.getItem("loginData")).token;
           
               // Register Dealer
               const response = await axios.post("/api/patientnotes/create", encryptedData, {
                 headers: {
                   "Content-Type": "application/json",
                   Authorization: `Bearer ${token}`,
                 },
               });
           
              if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);
      
        // Backend returns an object, not { success: true }
        if (!decryptedResponse || !decryptedResponse.id) {
          toast.error("Failed to save progress notes.");
          return;
        }
      
        toast.success("Progress Note added successfully!");
      
        // Close modal
        handleCloseProgressModal();
      
        // Optionally refresh list:
        // fetchProgressNotes();
      
      } else {
        toast.error("Failed to save progress notes.");
      }
      
            } catch (error) {
           console.error("Registration Error:", error);
         
           let errorMessage = "Registration failed"; // default message
         
           if (error.response) {
             const data = error.response.data;
         
             // ✅ If backend sends a structured JSON with a 'message' field
             if (typeof data === "object" && data.message) {
               errorMessage = data.message;
             } 
             // ✅ If backend sends a plain text message
             else if (typeof data === "string") {
               errorMessage = data;
             }
           } 
           // ✅ For network or other unexpected errors
           else if (error.message) {
             errorMessage = error.message;
           }
         
           toast.error(errorMessage);
         } finally {
           setLoading(false);
         }
           };
       
        const handleOpenDelearModal = (DelearId,DelearName) => {
          setSelectedDelearId(DelearId);
          setSelectedDelearName(DelearName);
      
          setOpenDelearModal(true);
        };
        
        const handleCloseDelearModal = () => {
          setOpenDelearModal(false);
          setSelectedDelearId(null);
          setSelectedDelearName(null);
      
        };
        const handleCloseProgressModal = () => {
    setOpenProgressModal(false);
    setSelectedPatientId(null);
    setProgressNote({
  id: "",
  ccid: userid,
  patientid: "",
  notes: "",
});
     setError(""); // reset validation error
  };
    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const secretKey = await fetchSecretKey();
            const token = JSON.parse(localStorage.getItem("loginData"))?.token;

            if (!token) throw new Error("Authentication token not found.");

            const response = await axios.get(`/api/dutydoctor/notifications/page/${userid}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

             if (response.status === 200) {

            const decryptedData = decryptBody(response.data, secretKey);

            // API RETURNS ARRAY DIRECTLY
            const allNotifications = Array.isArray(decryptedData)
                ? decryptedData
                : [];

            // FILTER CRITICAL ONLY
            const criticalNotifications = allNotifications.filter(
                (n) => n.type === "CRITICAL_VITAL"
            );

            setNotifications(criticalNotifications);

            setNotificationCount(criticalNotifications.length);
        }

    } catch (error) {

        console.error("Error fetching notifications:", error);

    } finally {

        setLoading(false);
    }
};

   useEffect(() => {
    if (!userid) return;

    fetchNotifications();
}, [location.key]);

const pushSosToDoctor = async (patientId, sosId) => {
  try {
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    const payload = {
      patientId: patientId,
      sosId: String(sosId).trim(),
    };

    const response = await axios.post(
      "/api/pushSosToDoctor",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      toast.success("SOS pushed to doctor successfully");
    }
  } catch (error) {
    console.error("Push SOS Error:", error);
    toast.error("Failed to push SOS to doctor");
  }
};

    const handleAccept = async (e, id) => {
        e.stopPropagation();
        try {
            const secretKey = await fetchSecretKey();
            const payload = {
                notificationId: id,
                action: "ACCEPT"
            };
            const encryptedPayload = encryptBody(payload, secretKey);
            const token = loginData?.token; 

            const response = await axios.post("/api/dutydoctor/alerts/action", encryptedPayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "text/plain",
                },
            });



            if (response.status === 200) {
                toast.success("Alert accepted successfully");
                fetchNotifications();
                 setNotifications((prev) =>
                prev.map((item) =>
                    item.sosid === id
                        ? { ...item, status: "ACCEPTED" }
                        : item
                )
            );
        }
        } catch (error) {
            console.error("Error accepting alert:", error);
            toast.error("Failed to accept alert");
        }
    };

    // Scroll to highlighted item when notifications are loaded
    useEffect(() => {
        if (highlightId && notifications.length > 0 && itemRefs.current[highlightId]) {
            itemRefs.current[highlightId].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [highlightId, notifications]);

    const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
    const dotPositions = [
        { top: "5%", left: "50%" },
        { top: "20%", left: "80%" },
        { top: "50%", left: "95%" },
        { top: "80%", left: "80%" },
        { top: "95%", left: "50%" },
        { top: "80%", left: "20%" },
        { top: "50%", left: "5%" },
        { top: "20%", left: "20%" },
    ];

    const notifyPatientForVideoCall = async (patientId, roomName) => {
      try {
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        await axios.post(
          "/api/video-call/start",
          { patientId, roomName },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } catch (error) {
        console.error("Failed to notify patient", error);
      }
    };
    
    const generateSecureRoomName = (carecordId, patientId) => {
      const timestamp = Date.now().toString(36);
    
      const randomArray = new Uint32Array(2);
      window.crypto.getRandomValues(randomArray);
    const randomString = Array.from(randomArray)
        .map((num) => num.toString(36))
        .join("");
    
    
      return `doctor-patient-${carecordId}-${patientId}-${timestamp}-${randomString}`;
    };
    const sosIconStyle = {
  color: "#d32f2f",
  backgroundColor: "rgba(211, 47, 47, 0.08)",
  "&:hover": {
    backgroundColor: "#d32f2f",
    color: "#fff",
    transform: "scale(1.05)",
  },
  transition: "all 0.3s ease",
};
    return (
        <main>
            <MedicalAbstractBackground />
            <DashboardNavbar notificationCount={notificationCount} />

            <div className="container-xl p-10 px-11" style={{ position: "relative", left: "100px" }}>
                {/* Header similar to NotificationDetails but for SOS */}
                <a href="/#/track/sos-notifications" className="text-decoration-none">
                    <h3
                        className="text-white display-6 d-flex justify-content-center align-items-center gap-2"
                        style={{
                            textAlign: "center",
                            width: "100%",
                            margin: "0 auto",
                             color: "#000",
                        }}
                    >
                        <span className="material-icons" style={{ fontSize: "40px" }}>
                           
                        </span>
                        Critical Notifications
                    </h3>
                </a>
                <hr className="mt-0 mb-5" />

                <div className="container-xl px-4" style={{ padding: "10px", maxWidth: "800px", margin: "30px auto" }}>
                    {loading ? (
                        <Box
                            sx={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                zIndex: 9999,
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    width: 80,
                                    height: 80,
                                    animation: `${spinAnimation} 1.5s linear infinite`,
                                }}
                            >
                                {dotPositions.map((pos, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: "50%",
                                            backgroundColor: "#1A237E",
                                            position: "absolute",
                                            ...pos,
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    ) : notifications.length > 0 ? (
                        <Stack spacing={2} mt={3}>
                            {notifications.map((n, index) => {
                                        const isAccepted = n.status === "ACCEPTED";
const mainColor = isAccepted ? "#2e7d32" : "#d32f2f";
const lightBg = isAccepted ? "#e8f5e9" : "#ffebee";

const iconStyle = {
  color: mainColor,
  backgroundColor: `${mainColor}14`,
  "&:hover": {
    backgroundColor: mainColor,
    color: "#fff",
    transform: "scale(1.1)",
  },
  transition: "all 0.3s ease",
};
                                // Debugging logs
                                console.log("Checking highlight:", { itemID: n.notificationId, highlightId, match: String(n.notificationId) === String(highlightId) });

                                const isHighlighted = highlightId && String(n.notificationId) === String(highlightId);

                                // Reuse color logic or enforce SOS redness
                                let bgColor = "#ffebee";       // light red
                                let borderColor = "#d32f2f";
                                let textColor = "#b71c1c";

                                // If specifically highlighted, maybe add extra visual cue
                                if (isHighlighted) {
                                    borderColor = "#ff0000";
                                    bgColor = "#ffcdd2"; // slightly darker red bg
                                }

                                return (
                                    <div ref={(el) => (itemRefs.current[n.notificationId] = el)} key={n.notificationId}>
                                        <Alert
  severity={isAccepted ? "success" : "error"}
  sx={{
    mb: 2,
    borderRadius: 3,
    transition: "all 0.3s ease",
     overflow: "hidden",
 "& .MuiAlert-message": {
      width: "100%",
    },
    // 🎨 Background
    backgroundColor: isAccepted
      ? isHighlighted
        ? "#c8e6c9"   // darker green if highlighted
        : "#e8f5e9"
      : isHighlighted
      ? "#ffcdd2"     // darker red if highlighted
      : "#ffebee",

    // 🎯 Border
    border: isHighlighted
      ? "2px solid #ff0000"
      : isAccepted
      ? "1px solid #2e7d32"
      : "1px solid #d32f2f",

    // 💡 Shadow boost on highlight
    boxShadow: isHighlighted
      ? "0 0 15px rgba(255,0,0,0.5)"
      : 3,

    "& .MuiAlert-icon": {
      color: isAccepted ? "#2e7d32" : "#d32f2f",
    },
  }}
>

                <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {/* PATIENT NAME */}
                    
                    <AlertTitle sx={{ mb: 0 }}>
                      <strong
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const pId =
                            n.patientid ||
                            n.patientId ||
                            n.patientID;
                          navigate(`/ViewPatientProfile/${pId}`);
                        }}
                      >
                        {n.patientName || "SOS Alert"}
                      </strong>
                    </AlertTitle>

                    {/* ICONS RIGHT SIDE */}
 <Box
    sx={{
      display: "flex",
      gap: 1,
      justifyContent: "flex-end",
    }}
  >                      
                      {/* ACCEPT */}
                      {!isAccepted && (
                        <Tooltip title="Accept Alert">
                          <IconButton
                            size="small"
                            onClick={(e) =>
                              handleAccept(e, n.notificationId)
                            }
                            sx={{
                              color: "#2e7d32",
                              backgroundColor:
                                "rgba(46,125,50,0.08)",
                              "&:hover": {
                                backgroundColor: "#2e7d32",
                                color: "#fff",
                              },
                            }}
                          >
                            <Icon>check_circle</Icon>
                          </IconButton>
                        </Tooltip>
                      )}

                      {/* CALL */}
                      <Tooltip title="Call">
                        <IconButton
                          size="small"
                          sx={sosIconStyle}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCallNumber(
                              `${n?.phonecountrycode}${n?.phoneNumber}`
                            );
                            setOpenCallModal(true);
                          }}
                        >
                          <CallIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      {/* PROGRESS NOTE */}
                      <Tooltip title="Progress Note">
                        <IconButton
                          size="small"
                          sx={sosIconStyle}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenProgressModal(
                              n.patientId
                            );
                          }}
                        >
                          <DescriptionIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      {/* EMAIL */}
                      <Tooltip title="Send Email">
                        <IconButton
                          size="small"
                          sx={sosIconStyle}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.location.href = `mailto:${n?.email || ""}`;
                          }}
                        >
                          <EmailIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      {/* VIDEO CALL */}
                      <Tooltip title="Video Call">
                        <IconButton
                          size="small"
                          sx={sosIconStyle}
                          onClick={(e) => {
                            e.stopPropagation();
                            const room =
                              generateSecureRoomName(
                                userid,
                                n?.patientId
                              );
                            setVideoRoomName(room);
                            setSelectedPatientId(
                              n?.patientUserId
                            );
                            setSelectedDoctorId(userid);
                            setOpenVideoCall(true);
                            notifyPatientForVideoCall(
                              n?.patientId,
                              room
                            );
                          }}
                        >
                          <VideoCallIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Post Consultation">
  <IconButton
    size="small"
    sx={sosIconStyle}
    onClick={(e) => {
      e.stopPropagation();

      navigate("/PostConsultationPage", {
        state: {
          patientId: n?.patientUserId,
        },
      });
    }}
  >
    <Icon>assignment</Icon>
  </IconButton>
</Tooltip>
                      {/* PUSH TO DOCTOR */}
{/* <Tooltip title="Push SOS To Doctor">
  <IconButton
    size="small"
    sx={sosIconStyle}
    onClick={(e) => {
      e.stopPropagation();
      pushSosToDoctor(n.patientId,  n.notificationId);
    }}
  >
    <Icon>local_hospital</Icon>
  </IconButton>
</Tooltip> */}
                    </Box>
                  </Box>

                  {/* MESSAGE */}
                  <Typography variant="body2">
                    {n.message}
                  </Typography>

                  {/* TIME */}
                  <Typography
                    variant="caption"
                    display="block"
                    color="text.secondary"
                    mt={1}
                  >
                    {n.timestamp}
                  </Typography>
                  </Alert>
          </div>
        );
      })}
    </Stack>
  ) : (
    <Typography
      variant="body1"
      align="center"
      color="text.secondary"
      mt={3}
    >
      No Critical notifications found.
    </Typography>
  )}
</div>
            </div>
             {openVideoCall && (
                    <DoctorVideoCallModal
                      open={openVideoCall}
                      onClose={() => setOpenVideoCall(false)}
                      roomName={videoRoomName}
                       doctorId={selectedDoctorId}
                patientId={selectedPatientId}
                userName={`${doctor_firstName || ""} ${doctor_lastName || ""}`}
                    />
                  )}
            
            
                   {/* Progress Note Modal */}
                  <Modal open={openProgressModal} onClose={handleCloseProgressModal}>
                    <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh" p={2}>
                      <Card sx={{ width: 
                        { xs: "95%", sm: "90%", md: "500px" },
                         padding: 3, maxHeight: "80vh",       // <-- limit height
                    overflowY: "auto",
                          }}>
                        <MDTypography variant="h6" mb={2} textAlign="center">
                          Add Progress Note
                        </MDTypography>
                      <form onSubmit={handleSubmit}>
                        <MDInput
                          multiline
                          rows={6}
                          value={progressNote.notes}
                          onChange={(e) =>
              setProgressNote((prev) => ({
                ...prev,
                notes: e.target.value,
              }))
            }
            
                          placeholder="Enter progress note..."
                          fullWidth
                          error={Boolean(error)}
                        />
                        
                    {error && (
                      <MDTypography variant="caption" color="error">
                        {error}
                      </MDTypography>
                    )}
                        <Box mt={2} display="flex" justifyContent="flex-end" gap={1} pb={1}>
                          <MDButton 
                        sx={{
                     background: "#1A237E",
                     color: "#fff",
                     "&:hover": {
                       background: "#1A237E", // darker shade on hover
                     },
                   }} onClick={handleCloseProgressModal}>
                            Cancel
                          </MDButton>
                          <MDButton 
                          variant="contained"
                          type="submit"
                         
                        //   onClick={handleSaveProgressNote}
                           sx={{
                     backgroundColor: "#1A237E !important",
                     color: "#fff", 
                     "&:hover": {
                       backgroundColor:"#1A237E !important", 
                     },
                   }} 
                          >
                            Save
                          </MDButton>
                         
                        </Box>
                         </form>
                      </Card>
                    </MDBox>
                  </Modal>
        </main>
        
    );
}

export default  CriticalNotificationPage;
